export const isPlainEmptyObject = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  return Object.keys(value).length === 0;
};

export const extractKeychainErrorMessage = (response, fallback = 'Request failed') => {
  if (!response || isPlainEmptyObject(response)) {
    return 'Hive Keychain returned an empty response. Please try again.';
  }

  const directMessage = typeof response.message === 'string' ? response.message.trim() : '';
  if (directMessage) return directMessage;

  const errorValue = response.error;
  if (typeof errorValue === 'string' && errorValue.trim()) {
    return errorValue.trim();
  }

  if (errorValue && typeof errorValue === 'object') {
    const nestedCandidates = [errorValue.message, errorValue.description, errorValue.error];
    for (const candidate of nestedCandidates) {
      if (typeof candidate === 'string' && candidate.trim()) {
        return candidate.trim();
      }
    }

    if (!isPlainEmptyObject(errorValue)) {
      try {
        return JSON.stringify(errorValue);
      } catch {
        // ignore stringify errors and fall through
      }
    }
  }

  return fallback;
};
